import { render } from "./StudentPage.vue?vue&type=template&id=b838d02a&scoped=true"
import script from "./StudentPage.vue?vue&type=script&lang=js"
export * from "./StudentPage.vue?vue&type=script&lang=js"

import "./StudentPage.vue?vue&type=style&index=0&id=b838d02a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b838d02a"]])

export default __exports__